import React, { useContext } from "react";
import ImageContainer from "@components/imageContainer";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";
import { styled as styledCommon } from "@acko-tech/building-blocks.ui.common";
import { resolvePath } from "@utils/resolvePath";
import { Context } from "@components/useContext/context";
import DOMPurify from "isomorphic-dompurify";
import Hyperlink from "@components/common/hyperlink";

interface ContainerProps {
  gap?: string;
}

const Container = styled(Flex)<ContainerProps>`
  padding: 12px 12px 15px 0px;
  flex-direction: column;
  box-sizing: border-box;
  color: #36354c;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  width: 100%;
  z-index: 1;
  gap: ${(props) => props.gap || "0px"};
  span {
    font-weight: 600;
  }
`;

const Wrapper = styledCommon.div`
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0px;
  width: 100vw;
  height: ${(props) => props.height || "175px"};
  left: 0px;
  right: 0px;
  pointer-events: none;
  border: 1px solid #efe9fb;
  ${(props) =>
    props.isOffered
      ? `background-image: url(${resolvePath("/images/Yellow.svg")});`
      : `background-image: url(${resolvePath("/images/Green.svg")});`}
`;

const Question = styled(Flex)`
  font-size: 18px;
  color: #040222;
  font-weight: 500;
`;

const Para = styled(Flex)`
  font-size: 12px;
  line-height: 18px;
  width: 90%;
`;

const GradientHeader = ({ isOffered = false, height }) => {
  const { isDesktop } = useContext(Context);
  return isDesktop ? null : <Wrapper isOffered={isOffered} height={height} />;
};

const PageHeadingWithImageAndDesc = ({ children, ...props }) => {
  const {
    isOffered = false,
    gap,
    question,
    src,
    height = 50,
    width = 50,
    para,
    headerHeight,
    styles,
    actions
  } = props || {};

  const { isDesktop } = useContext(Context);
  const { on_click } = actions || {};

  return (
    <>
      <GradientHeader isOffered={isOffered} height={headerHeight} />
      <Container gap={gap}>
        <Flex
          justifyContent="space-between"
          alignItems="center"
          style={{ width: "100%" }}
        >
          <Question
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(question) }}
          />
          <ImageContainer
            imgSrc={src}
            alt=""
            height={height}
            width={width}
            styles={styles}
          />
        </Flex>
        <Para dangerouslySetInnerHTML={{ __html: para }} />
        <Hyperlink
            clickHandler={() => {
              if (on_click?.length > 0) {
                on_click?.forEach((eachFunc: any) => {
                  typeof eachFunc.funCall === "function" &&
                    eachFunc.funCall(eachFunc.args);
                });
              }
            }}
            type="UNDERLINE"
            is_visible={true}
            text="Learn more"
            styles={{
              display: "inline-block",
              width: "max-content",
              marginBottom: "16px"
            }}
          />
      </Container>
    </>
  );
};

export default PageHeadingWithImageAndDesc;
